import { Box, CircularProgress } from '@mui/material'

/**
 * Fills whatever region it is placed in and centres a spinner. It used to wrap
 * itself in `Page`, which brought the old 36px inset with it.
 */
export const Loader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        alignItems: 'center',
        justifyContent: 'center',
        p: '24px',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
